if (!customElements.get('wls-blogs')) {
    class WLSBlogs extends HTMLElement {
        constructor() {
            super();
            this.classes = {
                slider: 'js-wls-blogs-slider',
                list: 'splide__list',
                item: 'splide__slide'
            };
    
            this.elements = {
                slider: this.querySelector(`.${this.classes.slider}`),
                list: this.querySelector(`.${this.classes.list}`),
                items: this.querySelectorAll(`.${this.classes.item}`)
            };

            this.resizeHandler = this.handleResize.bind(this);
        }

        connectedCallback() {
            if (this.checkIfEmpty()) return;
            this.init();
            window.addEventListener('resize', this.resizeHandler);
        }

        disconnectedCallback() {
            if (this.splide) {
                this.splide.destroy(true);
                this.splide = null;
            }
            window.removeEventListener('resize', this.resizeHandler);
            if (this.resizeTimeout) {
                clearTimeout(this.resizeTimeout);
            }
        }

        checkIfEmpty() {
            const listInner = this.elements.list;
            if (!listInner || !listInner.children.length) {
                this.style.display = 'none';
                return true;
            }
            return false;
        }
    
        init() {
            if (!this.shouldInitialize()) return;
            this.initializeSplide();
        }

        shouldInitialize() {
            if (!this.elements.slider || !this.elements.items.length) return false;
    
            const width = window.innerWidth;
            const slidesCount = this.elements.items.length;
    
            if (slidesCount <= 1 && width <= 768) return false;
            if (slidesCount <= 2 && width > 768) return false;
            if (slidesCount < 3 && width > 1024) return false;

            return true;
        }

        handleResize() {
            if (this.resizeTimeout) {
                clearTimeout(this.resizeTimeout);
            }
    
            this.resizeTimeout = setTimeout(() => {
                const shouldInit = this.shouldInitialize();
    
                if (shouldInit && !this.splide) {
                    this.initializeSplide();
                } else if (!shouldInit && this.splide) {
                    this.splide.destroy(true);
                    this.splide = null;
                }
            }, 300);
        }

        initializeSplide() {
            this.splide = new Splide(this.elements.slider, {
                type: 'slide',
                perPage: 3,
                gap: '32px',
                pagination: true,
                arrows: true,
                drag: true,    
                arrows: false,
                pagination: false,
                pauseOnHover: true,
                breakpoints: {
                    768: {
                        perPage: 1
                    },
                    1200: {
                        perPage: 3
                    }
                }

            });
    
            this.splide.mount();
        }    

    }

    customElements.define('wls-blogs', WLSBlogs);
}
